export default __webpack_public_path__ + "static/articulo9-605002ecb3b80d77ce0362984915c7e3.png";